import { Flex, Breadcrumb, Button, Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Aside from "./component/Aside";
import ChartSkeleton from "../../../../../../../../atom/ChartSkeleton";
import MenuActions from "../../../../../../../../atom/MenuActions";
import PlaceholderChart from "./component/PlaceholderChart";
import SectionHistorical from "../../../../component/ModalLevelProductDetails/components/SectionHistorical";
import SectionPlanning from "../../../../component/ModalLevelProductDetails/components/SectionPlanning";
import SectionRisk from "../../../../component/ModalLevelProductDetails/components/SectionRisk";
import TableHoldings from "./component/TableHoldings";

import StyledContainer from "./style";

import { isWindowReadonly } from "../../../../../advisor/helper";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as IconMenu } from "./image/icon_menu.svg";
import { ReactComponent as IconFavorite } from "./image/icon_favorite.svg";

const SectionBuilder = ({
  columnPreferences,
  favoriteProducts,
  handleActionArchive,
  handleActionDuplicate,
  handleActionRename,
  isModelDirty,
  loading,
  modelCalculation,
  modelData,
  onClickAddHoldings,
  onClickBreadcrumb,
  onClickColumns,
  onClickRemoveHolding,
  onClickReWeightPortfolio,
  onClickSaveModel,
  onToggleWeightType,
  selectedHoldings,
  submitToggleFavorite,
  updateHoldingWeight,
  userEmail,
  viewAdvisor,
  weightType,
}) => {
  const isTemplate = modelData?.isTemplate;

  const items = [
    {
      children: loading ? (
        <ChartSkeleton height={400} loading />
      ) : modelCalculation ? (
        <SectionHistorical
          calculation={modelCalculation?.data}
          loading={loading}
        />
      ) : (
        <PlaceholderChart />
      ),
      disabled: !modelCalculation,
      key: "historical",
      label: "Historical",
    },
    {
      children: (
        <SectionPlanning
          hideFooter
          loading={loading}
          projection={modelCalculation?.projection}
        />
      ),
      disabled: !modelCalculation,
      key: "planning",
      label: "Planning",
    },
    {
      children: (
        <SectionRisk calculation={modelCalculation?.data} loading={loading} />
      ),
      disabled: !modelCalculation,
      key: "risk",
      label: "Risk",
    },
  ];

  return (
    <StyledContainer>
      <Breadcrumb
        items={[
          {
            onClick: onClickBreadcrumb,
            title: (
              <Flex
                align="center"
                gap={8}
                style={{ cursor: "pointer", padding: 10 }}
              >
                <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 14 }} />
                <b style={{ fontSize: 12 }}>All Models</b>
              </Flex>
            ),
          },
        ]}
      />

      <Flex gap={54}>
        <Flex flex="1 1 auto">
          <main>
            <Flex justify="space-between" style={{ marginBottom: 32 }}>
              <h2>{modelData?.Name}</h2>

              <Flex gap={16}>
                <Button
                  icon={<IconFavorite />}
                  onClick={() => submitToggleFavorite(modelData?._id)}
                  shape="round"
                  type="text"
                >
                  {favoriteProducts?.includes(modelData?._id)
                    ? "Remove from Favorites"
                    : "Add to Favorites"}
                </Button>
                <Button
                  disabled={
                    loading ||
                    !isModelDirty ||
                    isTemplate ||
                    Math.round(
                      selectedHoldings.reduce((acc, it) => acc + it.weight, 0) *
                        100
                    ) /
                      100 !==
                      1
                  }
                  onClick={onClickSaveModel}
                  shape="round"
                  type="primary"
                >
                  Save Changes
                </Button>
                <MenuActions
                  items={[
                    {
                      disabled: isWindowReadonly(),
                      hidden: viewAdvisor && modelData?.creator !== userEmail,
                      key: "rename",
                      label: "Rename",
                      onClick: () => handleActionRename(modelData._id),
                    },
                    {
                      disabled: isWindowReadonly(),
                      key: "duplicate",
                      label: "Duplicate",
                      onClick: () => handleActionDuplicate(modelData._id),
                    },
                    {
                      disabled: isWindowReadonly(),
                      hidden: viewAdvisor && modelData?.creator !== userEmail,
                      key: "archive",
                      label: "Archive",
                      onClick: () => handleActionArchive(modelData._id),
                    },
                  ].filter(it => !it.hidden)}
                >
                  <Button
                    icon={<IconMenu />}
                    shape="round"
                    style={{ background: "#E6F4EF", padding: "0 4px" }}
                    type="text"
                  />
                </MenuActions>
              </Flex>
            </Flex>

            <Tabs items={items} />

            <TableHoldings
              columnPreferences={columnPreferences}
              isTemplate={isTemplate}
              onClickAddHoldings={onClickAddHoldings}
              onClickColumns={onClickColumns}
              onClickRemoveHolding={onClickRemoveHolding}
              onClickReWeightPortfolio={onClickReWeightPortfolio}
              onToggleWeightType={onToggleWeightType}
              selectedHoldings={selectedHoldings}
              updateHoldingWeight={updateHoldingWeight}
              weightType={weightType}
            />
          </main>
        </Flex>

        <Flex flex="0 0 359px">
          <Aside
            calculation={modelCalculation}
            hideSectionBeAware
            modelData={modelData}
          />
        </Flex>
      </Flex>
    </StyledContainer>
  );
};

export default SectionBuilder;
